import React from "react";
import classes from "./CommonCard.module.css";
import clsx from "clsx";
const CommonCard = ({ onClick, Tag = "div", children, className, ...rest }) => {
  return <Tag className={clsx(classes.wrapper, className)}>{children}</Tag>;
};
export default CommonCard;
